<template>
    <div>
        <Hero />
        <Locations />
    </div>
</template>

<script setup>
import Hero from '../components/Contact/Hero.vue';
import Locations from '../components/Contact/Locations.vue';
</script>

<style scoped>

</style>